/* Globo Product Options → Bambu Lab tile styling wrapper.
   Targets Globo's actual DOM:
     .gpo-dropdown    → transforms the multi-select dropdown into a grid of tile cards
                        (with product image fetched from asset_name or /products/{handle}.js)
     .gpo-switch      → adds a "No" button sibling, turning the toggle into a 2-button pair */
(function () {
  'use strict';

  var DEBUG = window.__GPO_BAMBU_DEBUG__ === true;
  var log = DEBUG ? console.log.bind(console, '[gpo-bambu]') : function () {};

  var imageCache = Object.create(null);


  /* --- Fallback: resolve the tile image when Globo has no linked product ----
     Globo add-ons used to carry gpo-data-product-handle, and the tile image was
     fetched from that product. When an add-on is switched to a MANUAL PRICE in
     Globo ("addon_type": "price"), Globo drops product_handle/variant_id, the
     attribute disappears from the DOM and every tile falls back to a grey
     placeholder. This table re-establishes the link by the option label, which
     Globo still renders, so the tiles keep showing the real product photo.
     Keyed by option-set id first (PlayStation Buttons points at a different
     product on the Galileo sets), then a shared default. */
  var ADDON_IMAGE_HANDLES = {
    'default': {
      'playstation buttons': 'playstation-buttons-for-gamesir-g8-plus-controller-easy-install',
      'case': 'case-for-expanded-modified-controllers-gamesir-g8-plus-g8-galileo-abxylute-s9-easy-smx-m15-memo-s3-rig-nacon-mg-x-pro',
      'cell phone holder': 'phone-holder',
      'phone holder': 'phone-holder',
      'dongle': 'gamesir-2-4g-wireless-dongle-receiver-gamepad-adapter-accessories-for-g8-plus-t4-cyclone-pro-t4-cyclone-2-4ghz',
      'rog flow z13 holders': 'rog-flow-z13-2025-holders-for-the-modded-gamesir-g8-plus-controller-copy',
      'rog flow z13 (2025) holders': 'rog-flow-z13-2025-holders-for-the-modded-gamesir-g8-plus-controller-copy',
      'onexplayer super x/v holders': 'onexplayer-super-x-holders-for-the-modded-controllers',
      'onexplayer super x holders': 'onexplayer-super-x-holders-for-the-modded-controllers',
      'onexplayer g1': 'onexplayer-g1-holders-for-the-modded-controllers',
      'grips': 'controller-grips-gamesir-g8-plus-galileo-legion-g7',
      'controller grips': 'controller-grips-gamesir-g8-plus-galileo-legion-g7',
      'hard carrying case': 'hard-carrying-case-gamesir-g8-plus-mfi'
    },
    /* Galileo sets ship the Galileo button set, not the G8 Plus one. */
    '1369878': {
      'playstation buttons': 'playstation-buttons-for-gamesir-g8-galileo-controller'
    }
  };

  function normalizeLabel(t) {
    return String(t || '')
      .replace(/\(.*?\)/g, ' ')   // drop the "(+ $9.99)" price suffix
      .replace(/[.\u2022]+$/g, '') // drop a trailing period or bullet
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function optionSetId(node) {
    var app = node && node.closest ? node.closest('[data-option-set-id]') : null;
    return app ? app.getAttribute('data-option-set-id') : '';
  }

  function resolveHandle(input, labelText) {
    var handle = input && input.getAttribute('gpo-data-product-handle');
    if (handle) return handle;
    var key = normalizeLabel(labelText);
    if (!key) return '';
    // The custom-print set contains different button hardware by model.
    if (key === 'playstation buttons' && input && input.closest('.cp-addon-galileo')) {
      return ADDON_IMAGE_HANDLES['1369878'][key];
    }
    var sid = optionSetId(input);
    var perSet = sid && ADDON_IMAGE_HANDLES[sid];
    if (perSet && perSet[key]) return perSet[key];
    return ADDON_IMAGE_HANDLES['default'][key] || '';
  }

  function switchLabelText(sw) {
    var el = sw.closest ? sw.closest('.gpo-element') : null;
    var span = el && el.querySelector('.gpo-label .label-content');
    return span ? span.textContent : '';
  }

  function getConfig() {
    var cfg = window.GPOConfigs && window.GPOConfigs.options;
    if (!cfg) return null;
    for (var pid in cfg) {
      if (Object.prototype.hasOwnProperty.call(cfg, pid)) {
        return cfg[pid];
      }
    }
    return null;
  }

  function getAssetUrl() {
    return (window.GPOConfigs && (window.GPOConfigs.embedAssetUrl || window.GPOConfigs.assetUrl)) || '';
  }

  function buildHandleMap(cfg) {
    var map = {};
    function walk(elements) {
      (elements || []).forEach(function (el) {
        if (el.option_values) {
          el.option_values.forEach(function (v) {
            if (v.product_handle) map[v.product_handle] = v;
          });
        }
        if (el.elements) walk(el.elements);
      });
    }
    if (cfg) walk(cfg.elements);
    return map;
  }

  function upsizeShopifyImg(url, width) {
    if (!url) return '';
    var absolute = url.indexOf('//') === 0 ? 'https:' + url : url;
    if (absolute.indexOf('cdn.shopify.com') === -1) return absolute;
    try {
      var parts = absolute.split('?');
      var base = parts[0];
      var query = parts[1] ? '?' + parts[1] : '';
      var dot = base.lastIndexOf('.');
      if (dot === -1) return absolute;
      var name = base.substring(0, dot);
      var ext = base.substring(dot);
      name = name.replace(/_\d+x(\d*)?$/i, '');
      return name + '_' + width + 'x' + ext + query;
    } catch (e) {
      return absolute;
    }
  }

  function fetchProductImage(handle) {
    if (!handle) return Promise.resolve('');
    if (imageCache[handle] !== undefined) return Promise.resolve(imageCache[handle]);
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var raw = (p && (p.featured_image || (p.images && p.images[0]))) || '';
        var url = upsizeShopifyImg(raw, 400);
        imageCache[handle] = url;
        return url;
      })
      .catch(function () { imageCache[handle] = ''; return ''; });
  }

  function attachImage(img, handle, data, assetUrl) {
    var assetSrc = (data && data.asset_name && assetUrl) ? (assetUrl + data.asset_name) : '';
    function applyUrl(url) {
      if (url) {
        img.classList.remove('bambu-tile-img--placeholder');
        img.src = url;
      } else {
        img.classList.add('bambu-tile-img--placeholder');
        img.removeAttribute('src');
      }
    }
    fetchProductImage(handle).then(function (url) {
      if (url) { applyUrl(url); return; }
      if (assetSrc) {
        img.onerror = function () { img.onerror = null; applyUrl(''); };
        img.src = assetSrc;
      } else {
        applyUrl('');
      }
    });
  }

  function transformDropdown(dropdown, handleMap, assetUrl) {
    if (dropdown.__bambuTransformed) return;
    dropdown.__bambuTransformed = true;
    dropdown.classList.add('bambu-dropdown-grid');

    // Force the list visible as a grid, override any inline or cascading hide
    var button = dropdown.querySelector('.dropdown-button');
    if (button) button.style.display = 'none';
    var list = dropdown.querySelector('.dropdown-list');
    if (list) {
      list.style.display = 'grid';
      list.style.position = 'static';
      list.style.visibility = 'visible';
      list.style.opacity = '1';
      list.style.transform = 'none';
      list.style.maxHeight = 'none';
      list.style.overflow = 'visible';
    }

    var items = dropdown.querySelectorAll('.dropdown-item.gpo-ov-item');
    if (!items.length) return;

    items.forEach(function (item) {
      item.classList.add('bambu-tile');
      var input = item.querySelector('input');
      var label = item.querySelector('label');
      if (!input || !label) return;

      var handle = resolveHandle(input, input.getAttribute('original-value') || input.value);
      var data = handle ? handleMap[handle] : null;

      if (!label.querySelector('img.bambu-tile-img')) {
        var img = document.createElement('img');
        img.className = 'bambu-tile-img';
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        label.insertBefore(img, label.firstChild);
        attachImage(img, handle, data, assetUrl);
      }
    });

    function sync() {
      items.forEach(function (item) {
        var inp = item.querySelector('input');
        if (inp && inp.checked) item.classList.add('bambu-selected');
        else item.classList.remove('bambu-selected');
      });
    }
    sync();
    dropdown.addEventListener('change', sync, true);
    dropdown.addEventListener('click', function () { setTimeout(sync, 50); }, true);
    log('transformed dropdown with', items.length, 'items');
  }

  function wrapSwitchAsTile(sw, handle, data, assetUrl) {
    var element = sw.closest('.gpo-element');
    if (!element || element.classList.contains('bambu-switch-tile')) return;
    element.classList.add('bambu-switch-tile');

    var body = document.createElement('div');
    body.className = 'bambu-switch-tile-body';
    while (element.firstChild) body.appendChild(element.firstChild);

    var imgWrap = document.createElement('div');
    imgWrap.className = 'bambu-switch-tile-imgwrap';
    var img = document.createElement('img');
    img.className = 'bambu-tile-img';
    img.alt = '';
    img.loading = 'lazy';
    img.decoding = 'async';
    imgWrap.appendChild(img);

    element.appendChild(imgWrap);
    element.appendChild(body);
    attachImage(img, handle, data, assetUrl);
  }

  function transformSwitch(sw, handleMap, assetUrl) {
    if (sw.__bambuTransformed) return;
    var input = sw.querySelector('input[type="checkbox"]');
    var label = sw.querySelector('label');
    if (!input || !label) return;
    sw.__bambuTransformed = true;
    sw.classList.add('bambu-switch');

    var handle = resolveHandle(input, switchLabelText(sw));
    var data = handle ? handleMap[handle] : null;
    wrapSwitchAsTile(sw, handle, data, assetUrl);

    label.classList.add('bambu-switch-btn', 'bambu-switch-add');
    var span = label.querySelector('span');
    var originalText = (span && span.textContent && span.textContent.trim()) || 'Add';
    if (!span || span.textContent.trim() !== 'Add') {
      if (span) span.textContent = 'Add';
      else label.textContent = 'Add';
    }

    var noBtn = document.createElement('button');
    noBtn.type = 'button';
    noBtn.className = 'bambu-switch-btn bambu-switch-no';
    noBtn.textContent = 'No';
    noBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (input.checked) {
        input.checked = false;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
      sync();
    });
    sw.appendChild(noBtn);

    function sync() {
      if (input.checked) {
        label.classList.add('bambu-selected');
        noBtn.classList.remove('bambu-selected');
      } else {
        label.classList.remove('bambu-selected');
        noBtn.classList.add('bambu-selected');
      }
    }
    sync();
    input.addEventListener('change', sync);
    log('transformed switch: "' + originalText + '"');
  }

  function moveOptionsAboveBuyButtons() {
    var gpo = document.querySelector('.gpo-container');
    if (!gpo || gpo.__bambuMoved) return;
    var buyButtons = document.querySelector('.product-form__buttons');
    if (!buyButtons || !buyButtons.parentNode) return;
    if (buyButtons.contains(gpo) || gpo.contains(buyButtons)) {
      buyButtons.parentNode.insertBefore(gpo, buyButtons);
    } else if (gpo.parentNode === buyButtons.parentNode) {
      buyButtons.parentNode.insertBefore(gpo, buyButtons);
    } else {
      buyButtons.parentNode.insertBefore(gpo, buyButtons);
    }
    gpo.__bambuMoved = true;
    gpo.setAttribute('data-bambu-moved', '1');
    log('moved gpo-container above product-form__buttons');
  }

  function scan() {
    var cfg = getConfig();
    var handleMap = buildHandleMap(cfg);
    var assetUrl = getAssetUrl();

    document.querySelectorAll('.gpo-dropdown').forEach(function (d) {
      transformDropdown(d, handleMap, assetUrl);
    });
    document.querySelectorAll('.gpo-switch').forEach(function (s) {
      transformSwitch(s, handleMap, assetUrl);
    });
    moveOptionsAboveBuyButtons();
  }

  function init() {
    scan();
    var obs = new MutationObserver(function () {
      clearTimeout(init._t);
      init._t = setTimeout(scan, 100);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
